export const numberRegexp = /[^0-9]/g;

export const phoneRegExp = /^(\d{2,3})(\d{3,4})(\d{4})$/;

export const phoneFormat = '$1-$2-$3';

export const emailRegexp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

export function toPhone(value: string) {
  return value.replace(numberRegexp, '').replace(phoneRegExp, phoneFormat);
}

export const cookieExp = /[;=,$.]/gi;
